.flare-composer-mode-strip .flare-composer-quick-mode-toggle {
  background: transparent;
  border: 0;
  border-radius: 8px;
  font-weight: 500;
  gap: 6px;
  padding: 0 8px;
}

.flare-composer-mode-strip .flare-composer-quick-mode-label {
  margin-left: 0;
  max-width: 120px;
  opacity: 1;
  transform: none;
}

.flare-composer-mode-strip .flare-composer-quick-mode-toggle.is-active {
  background: var(--flare-surface-bg-active);
  color: var(--flare-accent);
}

.flare-composer-mode-strip .flare-composer-quick-mode-toggle.is-active .flare-composer-quick-mode-label {
  margin-left: 0;
}
